export class CoordinatesService {
  private static CATRASTRO_API_BASE_URL =
    "https://ovc.catastro.meh.es/ovcservweb/ovcswlocalizacionrc/ovccoordenadas.asmx/Consulta_CPMRC?Provincia=&Municipio=&SRS=EPSG:4326";

  static async getCoordinatesByRefCat(
    refCat: string
  ): Promise<
    | { success: true; data: { lat: number; lng: number } }
    | { success: false; error: string }
  > {
    try {
      const rc = refCat.slice(0, 14);
      const url = `${CoordinatesService.CATRASTRO_API_BASE_URL}&RC=${encodeURIComponent(rc)}`;

      const response = await fetch(url);
      if (!response.ok) {
        return {
          success: false,
          error: `Coordinates API request failed with status ${response.status}`
        };
      }

      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "application/xml");

      const root = doc.documentElement;
      const namespace = root.namespaceURI;

      const latNode = doc.getElementsByTagNameNS(namespace || "", "ycen")[0];
      const lngNode = doc.getElementsByTagNameNS(namespace || "", "xcen")[0];

      if (latNode && lngNode) {
        const lat = parseFloat(latNode.textContent || "0");
        const lng = parseFloat(lngNode.textContent || "0");

        return {
          success: true,
          data: { lat, lng }
        };
      } else {
        return {
          success: false,
          error: `No coordinates found for RefCat: ${refCat}`
        };
      }
    } catch (error: any) {
      return {
        success: false,
        error: `Error fetching coordinates: ${error.message}`
      };
    }
  }
}
